// extracted by mini-css-extract-plugin
export default {"root":"applications-components-common-Legends-button-group-module__root","label":"applications-components-common-Legends-button-group-module__label"};
    if(module.hot) {
      // 1791528099948
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  